<template>
  <div>

    <v-row @click="toggleExpand" no-gutters class="text-body-1 align-center px-1"
      style="flex-wrap: nowrap; min-width: 300px;">
      <v-col cols="4">
        <v-row no-gutters>
          <v-col cols="12" sm="6" class="text-body-2">
            <event-icon value="DEPARTURE" />
            <span>{{ value.timeDeparture | localMoment('HH:mm') }}</span>
            <v-badge :color="diffColor(value.depDiffMinutes)" v-if="value.depDiffMinutes !== 0"
              :content="timeDiffPrinted(value.depDiffMinutes)" inline></v-badge>


            <v-row no-gutters class="hidden-sm-and-down align-center">
              <v-col cols="6" sm="3" class="text-body-2">
                <v-icon small color="info" class="hidden-xs-only">mdi-map-marker-outline</v-icon>
                <span class="text-caption text-sm-body-2">
                  <template v-if="value.departureStand">
                    {{ value.departureStand }}
                  </template>
                  <template v-else>
                    -
                  </template>
                </span>
              </v-col>
              <v-col cols="6" sm="3" class="text-body-2">
                <v-icon small color="info" class="hidden-xs-only">mdi-import</v-icon>
                <span class="text-caption text-sm-body-2">
                  <template v-if="value.boardingGate">
                    {{ value.boardingGate }}
                  </template>
                  <template v-else>
                    -
                  </template>
                </span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="6" class="text-body-2">
            <event-icon value="ARRIVAL" />
            <span>{{ value.timeArrival | localMoment('HH:mm') }}</span>
            <v-badge :color="diffColor(value.arrDiffMinutes)" v-if="value.arrDiffMinutes !== 0"
              :content="timeDiffPrinted(value.arrDiffMinutes)" inline></v-badge>

            <v-row no-gutters class="hidden-sm-and-down align-center">
              <v-col cols="6" sm="3" class="text-body-2"><v-icon small color="info"
                  class="hidden-xs-only">mdi-map-marker-outline</v-icon>
                <span class="text-caption text-sm-body-2">
                  <template v-if="value.arrivalStand">
                    {{ value.arrivalStand }}
                  </template>
                  <template v-else>
                    -
                  </template>
                </span>
              </v-col>
              <v-col cols="6" sm="3" class="text-body-2"><v-icon small color="info"
                  class="hidden-xs-only">mdi-import</v-icon>
                <span class="text-caption text-sm-body-2">
                  <template v-if="value.arrivalGate">
                    {{ value.arrivalGate }}
                  </template>
                  <template v-else>
                    -
                  </template>
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

      </v-col>


      <v-col>
        <v-row no-gutters class="d-flex align-center">
          <v-col cols="12" sm="6" class="text-h6">
            {{ value.number }}<span v-if="value.suffix" class="warning--text">{{ value.suffix }}</span>
          </v-col>
          <v-col cols="12" sm="6" class="text-body-2">{{ value.actualDepApIata }} - {{ value.actualArrApIata }}</v-col>
        </v-row>
      </v-col>

      <v-col>
        <v-row no-gutters class="d-flex align-center">
          <v-col cols="12" sm="6">
            <v-icon v-if="value.calculatedTakeOffTime" color="error">mdi-airplane-clock</v-icon>
            <v-icon v-else small color="secondary">mdi-airplane</v-icon>
            <span class="font-weight-medium body-2">{{ value.aircraft }}</span>
          </v-col>
          <v-col cols="6" sm="3" class="text-body-2">
            <span class="font-weight-bold">{{ value.legState }}</span>
          </v-col>
        </v-row>
      </v-col>

      <v-col>
        <v-row no-gutters>
          <v-col cols="5" sm="3" class="d-flex align-center">
            <template v-if="value.pax">
              <v-icon small color="info" class="hidden-xs-only">mdi-human-male-female</v-icon><span
                class="text-caption">{{ value.pax.total }}</span>
            </template>
          </v-col>
          <v-col cols="7" sm="3" class="d-flex align-center">
            <span v-if="isLdmVisible" class="text-caption font-weight-black accent--text ml-1">LDM</span>
          </v-col>
          <v-col cols="12" sm="6" class="text-body-1">
            {{ value.state }}
          </v-col>
        </v-row>
      </v-col>

    </v-row>


    <v-expand-transition>
      <div v-show="expandedId === value.id">
        <v-divider></v-divider>
        <v-row no-gutters>
          <v-col>
            <v-btn icon @click="moreInfo"><v-icon>info</v-icon></v-btn>
            <v-btn x-small outlined v-if="isLdmVisible" @click="showLdm">LDM</v-btn>
          </v-col>

        </v-row>

      </div>
    </v-expand-transition>

  </div>
</template>

<script>
import EventIcon from '@/components/EventIcon'

export default {
  name: 'FlightItem',
  components: { EventIcon },
  props: {
    value: {
      type: Object,
      required: true
    },
    expandedId: {
      type: Number,
      required: false,
      default: 0
    },
    now: {
      type: Date,
      required: true
    },
  },
  data: () => ({
  }),
  computed: {
    arrStand() {
      return this.value.arrivalStand
    },
    depStand() {
      return this.value.departureStand
    },
    isLdmVisible() {
      return this.value.hasLdm === true
    }
  },
  methods: {
    diffColor(diff) {
      return diff < 5 ? 'secondary' : (diff > 20 ? 'error' : 'warning')
    },
    timeDiffPrinted(diff) {
      return diff === 0 ? '' : diff > 0 ? '+' + diff : diff
    },
    toggleExpand() {
      this.$emit('toggle', this.value.id)
    },
    moreInfo() {
      this.$emit('moreInfo', 'general')
    },
    showLdm() {
      this.$emit('moreInfo', 'ldm')
    }
  }
}
</script>

<style></style>
